import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const fetchData = createApi('pricememo', 'GET');

const PriceMemoSlice = createSlice({
  name: 'PriceMemo',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PriceMemoSlice.reducer;